import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {forkJoin, Subject, Subscription} from "rxjs";
import {ReadDefaultValuesPopupComponent} from "../read-default-values-popup/read-default-values-popup.component";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";

import {environment} from "../../../../environments/environment";
// import {logger} from "codelyzer/util/logger"; // Deprecated - removed
import {FEATURE_NORMALIZATION, FEATURE_PATTERNS} from '../../constants/supported-features-constant';
import {processCorruptedSpecialFeatures} from "../../../shared-module/components/corruptfeatures/corrupt-features-processing";
import {AppStateService} from "src/app/core-module/services/app-state.service";
import { AvailableFeaturesStateService } from "../../../core-module/services/state/available-features-state.service";
import { CloStateService } from "../../../core-module/services/state/clo-state.service";
import { CorruptFeaturesService } from "../../../core-module/services/state/corrupt-features.service";
import { DeviceConfigStateService } from "../../../core-module/services/state/device-config-state.service";
import { FeatureUtilsService } from "../../../core-module/services/state/feature-utils.service";
import { GraphStateService } from "../../../core-module/services/state/graph-state.service";
import { MultiOneHttpClient } from "../../../core-module/services/state/multi-one-http-client.service";
import { UiSignalsStateService } from "../../../core-module/services/state/ui-signals-state.service";
import {
  DEVICE_SEARCH_ENDPOINT,
  DEVICE_SEARCH_QUERY_PREFIX,
  PRIMARY_DEVICE_REGIONS,
} from "../../constants/configure-device-modal.constants";

const RESULTS_DISPLAY_MS = 750;

@Component({
  standalone: false,
  selector: "app-supported-features",
  templateUrl: "./supported-features.component.html",
  styleUrls: ["./supported-features.component.scss"],
})
export class SupportedFeaturesComponent implements OnInit, OnDestroy {
  @Input() public retryClicked;
  retryImg: boolean = false;
  allFeatures = [];
  hidePrevFeat: boolean = false;
  combineAllFeat: LegacyAny = [];
  finalIndex = 0;
  FinalArray = [];
  unsubscribe = new Subject<void>();
  envScehmaLIstApi: LegacyAny;
  availableFeatures: string[] = [];
  countRedGreen: LegacyAny = 0;
  subscription: Subscription;
  deviceInfo: LegacyAny;
  startConfigurationData: LegacyAny;
  allFeaturesOFDevice = {};
  invertedImg: boolean = false;
  greenArray = [];
  redArray = [];
  orangeArray = [];
  popupFailedFeatArray = [];
  regions: string[];
  searchName: LegacyAny[];
  apiList: LegacyAny = [];
  fullDeviceList = DEVICE_SEARCH_ENDPOINT;
  envDeviceListURL: string;
  url: LegacyAny;
  customerLoader;
  contniueBtnClicked: boolean = false;
  continueShowBtnStatus: boolean = false;
  contniueIntervalID: ReturnType<typeof setInterval>;
  private resultsTimeoutId?: ReturnType<typeof setTimeout>;
  @Input() public invalidFeatureData = [];
  pathVal: string;

  constructor(

    private readonly modalService: NgbModal,
    public route: Router,
    public activemodal: NgbActiveModal,
    private readonly appState: AppStateService,
    private readonly utils: FeatureUtilsService,
    private readonly availFeat: AvailableFeaturesStateService,
    private readonly corruptFeatures: CorruptFeaturesService,
    private readonly uiSignals: UiSignalsStateService,
    private readonly deviceConfig: DeviceConfigStateService,
    private readonly httpClient: MultiOneHttpClient,
    private readonly clo: CloStateService,
    private readonly graphState: GraphStateService
  ) {}

  private extractFeatures(data: LegacyAny[]): string[] {
    const features = new Set<string>();
    for (const element of data) {
      const val = element.toString();
      if (!this.addMatchingFeatures(val, features)) {
        const fallback = this.deriveDisplayNameFromRawKey(val);
        if (fallback) {
          features.add(fallback);
        }
      }
    }
    return Array.from(features).sort((a, b) => a.localeCompare(b));
  }

  private addMatchingFeatures(raw: string, features: Set<string>): boolean {
    let matched = false;
    for (const feature of FEATURE_PATTERNS) {
      if (feature.exclude?.test(raw)) {
        continue;
      }
      if (!feature.pattern.test(raw)) {
        continue;
      }
      if (feature.unique && features.has(feature.name)) {
        continue;
      }
      features.add(feature.name);
      matched = true;
    }
    return matched;
  }

  // Fallback so any new schema key that isn't yet in FEATURE_PATTERNS still
  // appears in the read-progress popup instead of being silently dropped.
  private deriveDisplayNameFromRawKey(raw: string): string | null {
    const rawKey = raw.replace(/^led-features:/i, "").split(":")[0] || raw;
    const base = rawKey.replace(/-\d+$/, "").replace(/-$/, "").toLowerCase();
    if (!base) {
      return null;
    }
    if (FEATURE_NORMALIZATION[base]) {
      return FEATURE_NORMALIZATION[base];
    }
    return base
      .replace(/([a-z])([0-9])/g, "$1 $2")
      .replace(/(^|\s|_)(\w)/g, (_m, sep: string, ch: string) => sep + ch.toUpperCase());
  }

  private normalizeFeatureName(name: string): string {
    const lower = name.toLowerCase();
    if (/^luminfoformat\d*-?$/.test(lower)) return "Luminaire Info";
    return FEATURE_NORMALIZATION[lower] || name;
  }

  ngOnInit() {
    this.pathVal = this.utils.getImageUrl(window.location.hostname);
    this.appState.setProdInfoStatus("no");
    this.appState.setShowContinueNow("no");
    this.availFeat.getAvailableFeature.subscribe((data: LegacyAny) => {
      if (Array.isArray(data) && data.length > 0) {
        this.hidePrevFeat = true;
        this.allFeatures = this.extractFeatures(data);
        this.invertedImg = !!this.appState.getIsWriting();
        this.allFeaturesOFDevice = {
          selectedFeature: this.allFeatures,
          allFeature: data,
        };
        this.appState.setSupportedFeatures(this.allFeaturesOFDevice);
      } else {
        this.allFeatures = [];
      }
    });

    this.corruptFeatures.nonCorrupt.subscribe(() => {});
    this.corruptFeatures.corruptFeat.subscribe(() => {});
    this.corruptFeatures.getRedFeature.subscribe(() => {});
  }

  ngDoCheck() {
    const data = this.appState.getResultFeatures();
    if (data) {
      const readerDeviceFullInfo = this.appState.getReaderDeviceFullInfo();
      if (readerDeviceFullInfo) {
        this.deviceInfo = readerDeviceFullInfo;
      }

      const normalize = (el: LegacyAny) => this.normalizeFeatureName(el);

      const processArray = (arr: LegacyAny[]) =>
        [].concat(
          ...arr
            .filter(Boolean)
            .map(el => {
              if (Array.isArray(el)) {
                return el.map(e => normalize(e));
              }
              return normalize(el);
            })
        );

      const unique = (arr: string[]) => Array.from(new Set(arr));
      this.orangeArray = unique(processArray(data["orange"] || []));
      this.popupFailedFeatArray = unique(processArray(data["popupFailedFeat"] || []));

      // Green features: handle interdependent features
      const greenFeat: string[] = [];
      (data["green"] || []).forEach((element) => {
        if (element) {
          // Coerce items via String() so non-string entries don't crash toLowerCase().
          const normalized = Array.isArray(element)
            ? element.map(e => String(e).toLowerCase())
            : [String(element).toLowerCase()];
          if (normalized.length === 0) {
            return;
          }
          if (
            normalized.length > 1 &&
            (normalized.includes("dynadimmer") ||
              normalized.includes("lineswitch") ||
              normalized.includes("codedmains") ||
              normalized.includes("ampdim"))
          ) {
            normalized.forEach((interdepFeat) => {
              greenFeat.push(this.normalizeFeatureName(interdepFeat));
            });
          } else {
            greenFeat.push(this.normalizeFeatureName(normalized[0]));
          }
        }
      });
      this.greenArray = unique(greenFeat);

      // Red features - handle array of arrays format like [["DTL"]]
      const redFeat: string[] = [];
      (data["red"] || []).forEach((element) => {
        if (element) {
          if (Array.isArray(element)) {
            // Handle array format: [["DTL"]] or ["DTL"]
            element.forEach((feat) => {
              if (typeof feat === "string") {
                redFeat.push(this.normalizeFeatureName(feat.toLowerCase()));
              } else if (feat && feat.featureName) {
                // Handle object format: [{featureName: "DTL"}]
                redFeat.push(this.normalizeFeatureName(feat.featureName.toLowerCase()));
              }
            });
          } else if (typeof element === "string") {
            redFeat.push(this.normalizeFeatureName(element.toLowerCase()));
          }
        }
      });
      this.redArray = unique(redFeat);

      if(this.greenArray.length > 0 || this.redArray.length > 0 || this.orangeArray.length > 0) {
        this.appState.removeResultFeatures();
        this.appState.removeCorruptMemoryBankId();
        this.concatFeat();
      }

    }
  }

  concatFeat() {
    this.customerLoader = true;
    this.hidePrevFeat = false;
    this.retryImg = true;
    const green = [];
    const red = [];
    const orange = [];

    this.url = environment.multiOneAPIUrl;

    this.availableFeatures = this.availFeat.getListOfAvailableFeatures();

    const normalizedFeatures = this.availableFeatures.map(feature =>
      this.normalizeFeatureName(feature)
    );
    const uniqueNormalizedFeatures = Array.from(new Set(normalizedFeatures))
      .sort((a, b) => a.localeCompare(b));
    this.availFeat.setListOfAvailableFeatures(uniqueNormalizedFeatures);
    this.greenArray = this.utils.renameFeatures(this.greenArray);
    this.redArray = this.utils.renameFeatures(this.redArray);
    const redLower = this.redArray.map(item => item.toLowerCase());
    const greenLower = this.greenArray.map(item => item.toLowerCase());
    const orangeLower = this.orangeArray.map(item => item.toLowerCase());
    this.greenArray = this.greenArray.filter(
      item => !redLower.includes(item.toLowerCase())
    );
    this.orangeArray = this.orangeArray.filter(
      item => !redLower.includes(item.toLowerCase())
    );
    const updatedGreenLower = this.greenArray.map(item => item.toLowerCase());
    const updatedOrangeLower = this.orangeArray.map(item => item.toLowerCase());
    const commonOrange = this.greenArray.filter((item) =>
      updatedOrangeLower.includes(item.toLowerCase())
    );
    commonOrange.forEach((element) => {
      if (element) {
        orange.push({ name: element, flag: "orange" });
      }
    });
    const availableFeatures = this.availFeat.getListOfAvailableFeatures();
    const availableFeaturesLower = availableFeatures.map(f => f.toLowerCase());
    const corruptedFeaturesToProcess = processCorruptedSpecialFeatures(
      new Set(this.orangeArray),
      new Set(uniqueNormalizedFeatures),
      this.appState
    );
    this.orangeArray = Array.from(corruptedFeaturesToProcess);
    this.orangeArray.forEach((element) => {
      const elementLower = element.toLowerCase();
      if (element && !updatedGreenLower.includes(elementLower)) {
        const isAvailable = uniqueNormalizedFeatures.includes(elementLower);
        orange.push({
          name: element,
          flag: isAvailable ? "orange" : "unsupported"
        });
      }
    });
    for (let i = 0; i < this.greenArray.length; i++) {
      for (let j = 0; j < orange.length; j++) {
        if (this.greenArray[i].toLowerCase() === orange[j]["name"].toLowerCase()) {
          this.greenArray.splice(i, 1);
          i--; // adjust index after removal
          break;
        }
      }
    }

// Push remaining green features
    this.greenArray.forEach((element) => {
      if (element) {
        green.push({ name: element, flag: "green" });
      }
    });
    this.redArray.forEach((element) => {
      if (element) {
        red.push({ name: element, flag: "red" });
      }
    });
    this.FinalArray = green.concat(orange).concat(red);

// Filter red features (case-insensitive)
    const allFeat = this.appState.getSupportedFeatures();
    const filterRedFeatures = allFeat && allFeat["selectedFeature"] ? allFeat["selectedFeature"].filter(
      (item) => !greenLower.includes(item.toLowerCase())
    ) : [];
    if (this.FinalArray.length > 0) {
      this.sort(this.FinalArray);
    }

    clearTimeout(this.resultsTimeoutId);
    this.combineAllFeat = [...this.FinalArray];
    this.finalIndex = this.FinalArray.length;
    this.resultsTimeoutId = setTimeout(() => {
      this.handleFinalIndexComplete(this.appState.getReaderConfigurationData());
    }, RESULTS_DISPLAY_MS);
  }



  private handleFinalIndexComplete(config: LegacyAny): void {
    this.finalIndex++;

    if (!config) {
      this.handleNoConfig();
    } else if (this.deviceInfo) {
      this.handleWithDeviceInfo(config);
    } else {
      this.searchWith12Nc(config);
    }
  }

  private handleNoConfig(): void {
    const writingDevice = this.appState.getIsWriting();
    this.countRedGreen = this.countProblematicFeatures();
    this.customerLoader = false;

    if (!writingDevice) {
      this.handleReadingDevice();
    } else {
      this.handleWritingDevice();
    }
  }

  private countProblematicFeatures(): number {
    return this.FinalArray.filter(element =>
      ["red", "orange", "unsupported"].includes(element["flag"])
    ).length;
  }

  private handleReadingDevice(): void {
    this.hidePrevFeat = false;
    this.customerLoader = false;

    if (this.hasProblematicFeatures()) {
      this.openReadModal("read-device-modal-comp");
    } else {
      this.handleSuccessfulRead();
    }
  }

  private handleWritingDevice(): void {
    if (this.hasProblematicFeatures()) {
      this.openReadModal("read-device-modal-comp-transfer");
      this.countRedGreen = 0;
    } else {
      this.handleSuccessfulWrite();
    }
  }

  private hasProblematicFeatures(): boolean {
    return this.countRedGreen > 0 || this.popupFailedFeatArray.length > 0;
  }

  private openReadModal(windowClass: string): void {
    const modalRef = this.modalService.open(ReadDefaultValuesPopupComponent, {
      backdrop: "static",
      keyboard: false,
      windowClass: windowClass,
      centered: true,
      size: "lg",
    });

    modalRef.componentInstance.data = this.popupFailedFeatArray.length > 0
      ? this.popupFailedFeatArray
      : this.FinalArray;
  }

  private handleSuccessfulRead(): void {
    const multiDevice = this.appState.getStoreConcecutiveMultiple();

    if (multiDevice !== true) {
      this.closeModalAndReset();
    } else {
      this.handleMultiDeviceRead();
    }
  }

  private handleMultiDeviceRead(): void {
    const detectedReaderInfo = this.appState.getDetectedReaderInfo();

    if (this.shouldCloseForReader(detectedReaderInfo)) {
      this.uiSignals.modalClose("close");
      this.activemodal.close();
    }
    this.deviceConfig.showNextAndCancel = true;
  }

  private shouldCloseForReader(detectedReaderInfo: LegacyAny): boolean {
    return detectedReaderInfo &&
      (detectedReaderInfo.selectedReader == null ||
        detectedReaderInfo.selectedReader.peripheralType === "LCN9640");
  }

  private handleSuccessfulWrite(): void {
    const prodInfoStatus = this.appState.getProdInfoStatus();

    if (prodInfoStatus === "yes") {
      this.setupContinuePolling();
    } else {
      this.closeWithoutContinue();
    }
  }

  private setupContinuePolling(): void {
    this.appState.setShowContinueNow("yes");
    this.contniueIntervalID = setInterval(() => {
      const continueClicked = this.appState.getReadContinue();
      if (continueClicked === "yes") {
        this.closeModalAndReset();
      }
    }, 100);
  }

  private closeWithoutContinue(): void {
    this.appState.setShowContinueNow("no");
    this.closeModalAndReset();
  }

  private closeModalAndReset(): void {
    this.uiSignals.modalClose("close");
    this.activemodal.close();
    this.appState.setNormalFlow(false);
  }

  private handleWithDeviceInfo(config: LegacyAny): void {
    const writingDevice = this.appState.getIsWriting();

    if (!writingDevice) {
      this.getReaderValue(config);
    } else {
      // Preserve existing resp data from configurationData
      const existingConfig = this.appState.getConfigurationData();
      const existingResp = existingConfig?.resp || {};
      this.proceed(existingResp);
    }
  }

  getReaderValue(config) {

    this.envScehmaLIstApi = environment.multiOneAPIUrl;
    this.httpClient
      .getConfigurationAPI(
        this.envScehmaLIstApi,
        config["configurationID"]
      )
      .subscribe(
        (resp: LegacyAny) => {
          this.proceed(resp);
        },
        (err) => {
          // this.customerLoader = false;
          if (err.description === "Feature Configuration is empty.") {
            const resp = {};
            this.proceed(resp);
          }
        }
      );

  }
  proceed(resp: LegacyAny): void {
    if (!resp) {
      resp = {};
    }
    this.mergeInvalidFeatureData(resp);
    const readerInfo = this.appState.getSetReaderDEviceInfo();
    const features = this.appState.getSupportedFeatures();
    const swSchema = this.appState.getSoftwareSchema();
    const config = this.appState.getReaderConfigurationData();

    const readerDeviceInfo = this.appState.getReaderDeviceFullInfo();
    this.normalizeSelectedFeatures(features);
    resp = this.mergeSavedReadValue(resp);
    // Store a shallow clone: the code below (`delete resp["CLO"]` / `["AOC"]`
    // when those are flagged in `orangeArray`) mutates `resp` in place. That
    // mutation used to propagate into the stored saveReadValue because
    // `setState` only shallow-clones the top-level state, keeping the same
    // reference for nested payloads. Cloning here preserves the full read
    // payload in saveReadValue so downstream feature components (CLO / AOC)
    // can still fall back to it on re-render after the value was stripped
    // from `configurationData.resp` for the re-check flow.
    this.appState.setSaveReadValue({ ...resp });

    this.updateReadGraphs(resp);
    this.removeOrangeReadValues(resp);
    this.startConfigurationData = this.buildConfigurationData(
      resp, config, features, readerInfo, readerDeviceInfo, swSchema
    );
    this.appState.setCompareFirmwareNoLatest(
      readerInfo.deviceMetadata.deviceSwVersion
    );
    this.appState.setConfigurationData(this.startConfigurationData);
    this.continueAfterConfiguration(resp);
    this.customerLoader = false;
    this.finalIndex++;
  }

  private mergeInvalidFeatureData(resp: LegacyAny): void {
    this.invalidFeatureData.forEach((data: LegacyAny) => {
      const name = data["featureName"];
      resp[name] = data["featureParameters"];
      const upper = name ? name.toUpperCase() : null;
      if (upper && upper !== name) {
        resp[upper] = data["featureParameters"];
      }
      if (name && name.toLowerCase() === "codedmains") {
        resp["CodedMains"] = data["featureParameters"];
      }
    });
  }

  private normalizeSelectedFeatures(features: LegacyAny): void {
    const selectedFeatures = features?.selectedFeature;
    if (!selectedFeatures) {
      return;
    }
    for (const [original, alias] of [["ALO", "Alo"], ["AOC", "Aoc"], ["CLO", "Clo"]]) {
      const index = selectedFeatures.indexOf(original);
      if (index > -1) {
        selectedFeatures.splice(index, 1);
        selectedFeatures.push(alias);
      }
    }
  }

  private mergeSavedReadValue(resp: LegacyAny): LegacyAny {
    const savedReadValue = this.appState.getSaveReadValue();
    if (!savedReadValue) {
      return resp;
    }
    const allReadValues = { ...savedReadValue, ...resp };
    for (const key in allReadValues) {
      for (const responseKey in resp) {
        if (key === responseKey) {
          delete savedReadValue[key];
          savedReadValue[key] = resp[responseKey];
        }
      }
    }
    return savedReadValue;
  }

  private updateReadGraphs(resp: LegacyAny): void {
    if (resp.CLOLite && this.appState.getReadingDevice()) {
      this.clo.sendLitePower(resp.CLOLite.CloLiteInitialPowerLevel);
      this.clo.sendliteHour(resp.CLOLite.CloLiteMaximumWorkingHours);
      this.graphState.setEnableGraph(resp.CLOLite.CloLiteEnabled);
    }

    if (resp.CLO && this.appState.getReadingDevice()) {
      this.graphState.setEnableGraph(resp.CLO.CloEnabled);
    }
  }

  private removeOrangeReadValues(resp: LegacyAny): void {
    if (this.orangeArray.indexOf("CLO") > -1) {
      delete resp["CLO"];
    }

    if (this.orangeArray.indexOf("AOC") > -1) {
      delete resp["AOC"];
    }
  }

  private getPreservedFeatureMetadata(config: LegacyAny): LegacyAny {
    // Preserve selectedFeaturesInfo from existing configurationData on page refresh
    const existingConfigData = this.appState.getConfigurationData();
    const preservedSelectedFeatures = config['selectedFeaturesInfo']
      || (existingConfigData && Array.isArray(existingConfigData['selectedFeaturesInfo'])
          ? existingConfigData['selectedFeaturesInfo']
          : []);
    // Preserve the raw led-features:<key>-<12nc>:<version> list read-device
    // stashed on configurationData — required by feature-supported to discover
    // features that have no dedicated view (default-view flow).
    const preservedDeviceSchemas = Array.isArray(config?.['deviceSchemas']) && config['deviceSchemas'].length > 0
      ? config['deviceSchemas']
      : (Array.isArray(existingConfigData?.['deviceSchemas']) ? existingConfigData['deviceSchemas'] : []);
    // Reuse the schemas the read-device pre-fetch already downloaded so the
    // landing page avoids duplicate schema-details calls.
    const preservedPreFetchedSchemas =
      (existingConfigData && typeof existingConfigData['preFetchedFeatureSchemas'] === 'object')
        ? existingConfigData['preFetchedFeatureSchemas']
        : {};

    return {
      deviceSchemas: preservedDeviceSchemas,
      preFetchedFeatureSchemas: preservedPreFetchedSchemas,
      selectedFeaturesInfo: preservedSelectedFeatures,
    };
  }

  private buildConfigurationData(
    resp: LegacyAny, config: LegacyAny, features: LegacyAny,
    readerInfo: LegacyAny, readerDeviceInfo: LegacyAny, swSchema: LegacyAny
  ): LegacyAny {
    const metadata = this.getPreservedFeatureMetadata(config);
    return {
      configurationID: config["configurationID"],
      configurationIDUniqueDC: config["configurationIDUniqueDC"],
      deviceName: readerDeviceInfo[0]["deviceName"],
      device12nc: config["device12nc"],
      softwareVersion: readerInfo.deviceMetadata.deviceSwVersion,
      feature12Nc: config["feature12Nc"]
        ? config["feature12Nc"]
        : features["allFeature"],
      ...metadata,
      resp: resp,
      picture:
        "https://www.api.easydesignintool.signify.com" +
        this.deviceInfo[0].devicetypePicture,
      softwareVerSchema: swSchema["swschema"],
      flextuneSoftVer: swSchema["flextuneSoftVer"],
      multiconfigSoftVer: swSchema["multiconfigSoftVer"],
      luminSoftVer0: swSchema["luminSchemaVer0"],
      luminSoftVer3: swSchema["luminSchemaVer3"],
      luminSoftVer4: swSchema["luminSchemaVer4"],
      luminSoftVer5: swSchema["luminSchemaVer5"],
      dtlSoftVer: swSchema["dtlSchemaVer"],
      mindimlevelSoftVer: swSchema["mindimlevelSoftVer"],
      dalipsuSoftVer: swSchema["dalipsuSchemaVer"],
      dali102AddressingSoftVer: swSchema["dali102AddressingSoftVer"],
      dali102and207ConfigSoftVer: swSchema["dali102and207ConfigSoftVer"],
      auxSoftVer: swSchema["auxSoftVer"],
      lsiSoftVer: swSchema["lsiSoftVer"],
      aocmultichannelSoftVer: swSchema["aocmultichannelSoftVer"],
      otpSoftVer: swSchema["otpSoftVer"],
      dscSoftVer: swSchema["dscSoftVer"],
      lowmainslockSoftVer: swSchema["lowmainslockSoftVer"],
      dipswitchSoftVer: swSchema["dipswitchSoftVer"],
      mtpSoftVer: swSchema["mtpSoftVer"],
      dimminginterfaceSoftVer: swSchema["dimminginterfaceSoftVer"],
      cloSoftVer: swSchema["cloSoftVer"],
      aloSoftVer: swSchema["aloSoftVer"],
      aocSoftVer: swSchema["aocSoftVer"],
      touchdimSoftVer: swSchema["touchdimSoftVer"],
      diia253maintenanceSoftVer: swSchema["diia253maintenanceSoftVer"],
      corridorSoftVer: swSchema["corridorSoftVer"],
      ztvSoftVer: swSchema["ztvSoftVer"],
      ztvoutputSoftVer: swSchema["ztvoutputSoftVer"],
      lipSoftVer: swSchema["lipSoftVer"],
      rsoSoftVer: swSchema["rsoSoftVer"],
      ampdimSoftVer: swSchema["ampdimSoftVer"],
      astSoftVer: swSchema["astSoftVer"],
      cloliteSoftVer: swSchema["cloliteSoftVer"],
      dynadimmerSoftVer: swSchema["dynadimmerSoftVer"],
      dcemergencySoftVer: swSchema["dcemergencySoftVer"],
      lineswitchSoftVer: swSchema["lineswitchSoftVer"],
      owpSoftVer: swSchema["owpSoftVer"],
      codedmainsSoftVer: swSchema["codedmainsSoftVer"],
    };
  }

  private continueAfterConfiguration(resp: LegacyAny): void {
    const writingDevice = this.appState.getIsWriting();
    this.FinalArray.forEach((element: LegacyAny) => {
      if (element["flag"] === "red" || element["flag"] === "orange" || element["flag"] === "unsupported") {
        this.countRedGreen++;
      }
    });
    if (this.hasProblematicFeatures()) {
      this.openReadModal(writingDevice ? "read-device-modal-comp" : "read-device-modal-comp-transfer");
      if (!writingDevice) {
        this.countRedGreen = 0;
      }
      return;
    }
    if (writingDevice) {
      this.continueSuccessfulConfigurationWrite();
    } else {
      this.continueSuccessfulConfigurationRead(resp);
    }
  }

  private continueSuccessfulConfigurationWrite(): void {
    const multiDevice = this.appState.getStoreConcecutiveMultiple();
    if (multiDevice) {
      setTimeout(() => {
        this.deviceConfig.showNextAndCancel = true;
      }, 0);
      return;
    }
    setTimeout(() => {
      if (!this.utils.formattedApiCallError) {
        this.uiSignals.modalClose("close");
        this.activemodal.close();
      }
    }, 2000);
    this.appState.setNormalFlow(false);
  }

  private continueSuccessfulConfigurationRead(resp: LegacyAny): void {
    if (this.appState.getProdInfoStatus() === "yes") {
      this.setupContinuePolling();
      return;
    }
    this.closeWithoutContinue();
    if (resp) {
      this.route.navigate(["/featureLanding"]);
    }
  }

  continueBtnClickedOP() {
    if (this.contniueBtnClicked) {
      this.uiSignals.modalClose("close");
      this.activemodal.close();
      this.appState.setNormalFlow(false);

      this.route.navigate(["/featureLanding"]);
    }
  }
  sort(items) {
    items.sort(function (a, b) {
      return a.name - b.name || a.name.localeCompare(b.name);
    });
  }

  searchWith12Nc(searchText) {
    let j = 0;
    this.regions = [...PRIMARY_DEVICE_REGIONS];
    this.regions.forEach((element) => {
      this.searchTextValue(searchText.device12nc, {}, j);
      j++;
    });

    this.unsubscribe.next(undefined);
    this.searchName = [];
    const config = this.appState.getReaderConfigurationData();
    forkJoin(this.apiList).subscribe((resp) => {
      this.deviceInfo = [].concat.apply([], resp);
      this.appState.setReaderDeviceFullInfo(this.deviceInfo);
      this.getReaderValue(config);
    });
  }

  searchTextValue(searchText, headers?, j?) {
    if (this.url.length) {
      this.envDeviceListURL = `${this.url}${this.fullDeviceList}?device12nc=`;
      this.unsubscribe.next(undefined);
      this.apiList[j] = this.httpClient.apiCall(
        "get",
        `${this.envDeviceListURL}${searchText}&showArchive=true`,
        "",
        { headers: headers }
      );
    }
  }

  ngOnDestroy() {
    clearTimeout(this.resultsTimeoutId);
    if (this.contniueIntervalID) {
      clearInterval(this.contniueIntervalID);
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.availFeat.sendFeatures("");
    this.corruptFeatures.sendCorruptFeat("");
    this.corruptFeatures.sendNonCorrupt("");
  }
}
